import { object, string } from 'yup';

export default object().shape({
  postalCode: string()
    .nullable()
    .when('method', {
      is: method => method && method?.is_carrier_location,
      then: string().required(),
    }),
  servicePoint: object()
    .nullable()
    .when('method', {
      is: method => method && method?.is_carrier_location,
      then: object().required(),
    }),
});
